// ** React Imports
import { useEffect, useState } from 'react'

import { client } from 'src/utils/axios-client';
import { LeadScreenStore, LeadActivity, Lead, NextActivity, LeadAccountStore, ViewType, ActivityDialogStore, LeadCompanyStore, CompanyDialogStore } from 'src/stores/LeadStore';
import { leadEndpoints } from '../../../configs/endpoints';

// ** MUI Imports
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import { styled } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Tooltip from '@mui/material/Tooltip'
import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link';
import _ from 'lodash';
import LeadDataFormater from './LeadDataFormater';
import Badge, { BadgeProps } from '@mui/material/Badge';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import RadialBarChart from '../../common/RadialBarChart';
import StandardSkeleton from '../../common/StandardSkeleton';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import DoActivityAccountInfo from './DoActivityAccountInfo';
import DoActivitySprintInfo from './DoActivitySprintInfo';
import DoActivityCompanyInfo from './DoActivityCompanyInfo';



const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: 33,
        top: 10,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}));

const DoActivityContactRates = () => {
    const [value, setValue] = useState('Account');

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };
    
        return (
            <Box>
                <Grid container spacing={6}>
                    <Grid item xs={12}>
                        <Card variant="outlined">
                            <CardContent>
                                <Box >
                                    <TabContext value={value} >
                                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                            <TabList onChange={handleChange} variant="scrollable" scrollButtons>
                                                <Tab label="Account" value="Account" />
                                                <Tab label="Company" value="Company" />
                                                <Tab label="Sprint" value="Sprint" />
                                            </TabList>
                                        </Box>
                                        <TabPanel value="Account"  >
                                            <DoActivityAccountInfo />
                                        </TabPanel>
                                        <TabPanel value="Company" >
                                            <DoActivityCompanyInfo />
                                        </TabPanel>
                                        <TabPanel value="Sprint" >
                                            <DoActivitySprintInfo />
                                        </TabPanel>
                                    </TabContext>
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        )
    
}

export { DoActivityContactRates }

export default DoActivityContactRates;